/*
 * The connecting thread.
 *
 * Draws the masked twin of the dashed path, scrubbed to scroll, so the line
 * appears to be drawn on as the reader travels from the hero down through the
 * beats it passes behind. The visible dashed path never moves — only the mask
 * revealing it does.
 */
import { defineScene, drawLine } from '@theme/about-story';

defineScene('about-thread', (root) => {
	const mask = root.querySelector('[data-about-thread-mask]');
	const svg = root.querySelector('[data-about-thread-svg]');
	if (!mask || !svg) return;

	drawLine(mask, {
		trigger: svg,
		start: root.dataset.start || 'top 85%',
		end: root.dataset.end || 'bottom 40%',
		scrub: 1,
	});
});
